export default __webpack_public_path__ + "static/media/steps-cover-3.022cb503.png";